import { CSSProperties } from 'react'
import css from './badgeStatus.module.css'

interface IProps {
  style?: CSSProperties
  type: 'success' | 'default' | 'error' | 'processing' | 'warning' | 'dark' | 'blue' | 'loaderGray'
}

const BadgeStatus = (props: IProps) => {
  return <div className={css.wrapper} data-type={props.type} style={props.style} />
}

export default BadgeStatus
